// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import { LOGIN, FORGOT_PASSWORD, NEW_PASSWORD, VERIFY_TOKEN } from '../../../../common/constant'



export const actionLogin = createAsyncThunk('publicStore/actionLogin', async (params, thunkAPI) => {
    const response = await axios.post(LOGIN, params)
    return response.data
})

export const actionForgotPassword = createAsyncThunk('publicStore/actionForgotPassword', async (params) => {
    const response = await axios.post(FORGOT_PASSWORD, params)
    return response.data

})

export const actionNewPassword = createAsyncThunk('publicStore/actionNewPassword', async (params) => {
    const response = await axios.post(NEW_PASSWORD, params)
    return response.data
})

export const actionVerifyToken = createAsyncThunk('publicStore/actionVerifyToken', async (params) => {
    const response = await axios.post(VERIFY_TOKEN, params)
    return response.data
})



export const appPublicSlice = createSlice({
    name: 'publicStore',
    initialState: {

        //add
        loadingLogin: false,
        login: null,

        //forgot password
        loadingForgotPass: false,
        forgotPassword: null,

        //new password
        loadingNewPassword: false,
        newPassword: null,

        //verify password
        loadingVerifyPassword: false,
        verifyToken: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetLoginResponse: (state) => {
            state.login = null
        },
        resetForgotPasswordResponse: (state) => {
            state.forgotPassword = null
        },
        resetNewPasswordResponse: (state) => {
            state.newPassword = null
        },
        resetVerifyTokendResponse: (state) => {
            state.verifyToken = null
        },
    },
    extraReducers: builder => {
        builder
            //add
            .addCase(actionLogin.pending, (state) => {
                state.loadingLogin = true
            })
            .addCase(actionLogin.fulfilled, (state, action) => {
                state.loadingLogin = false
                state.login = action.payload
            })
            .addCase(actionLogin.rejected, (state) => {
                state.loadingLogin = false
            })

            //forgot password
            .addCase(actionForgotPassword.pending, (state) => {
                state.loadingForgotPass = true
            })
            .addCase(actionForgotPassword.fulfilled, (state, action) => {
                state.loadingForgotPass = false
                state.forgotPassword = action.payload
            })
            .addCase(actionForgotPassword.rejected, (state) => {
                state.loadingForgotPass = false
            })

            //new password
            .addCase(actionNewPassword.pending, (state) => {
                state.loadingNewPassword = true
            })
            .addCase(actionNewPassword.fulfilled, (state, action) => {
                state.loadingNewPassword = false
                state.newPassword = action.payload
            })
            .addCase(actionNewPassword.rejected, (state) => {
                state.loadingNewPassword = false
            })

            //verify password
            .addCase(actionVerifyToken.pending, (state) => {
                state.resetVerifyTokendResponse = true
            })
            .addCase(actionVerifyToken.fulfilled, (state, action) => {
                state.resetVerifyTokendResponse = false
                state.verifyToken = action.payload
            })
            .addCase(actionVerifyToken.rejected, (state) => {
                state.resetVerifyTokendResponse = false
            })
    }
})

export const { resetLoginResponse, resetForgotPasswordResponse, resetNewPasswordResponse, resetVerifyTokendResponse } = appPublicSlice.actions

export default appPublicSlice.reducer